import { inject, observer } from 'mobx-react'
import React from 'react'
import { ReactComponent as FacebookIcon } from "../../svg/facebook-login.svg";
import { ReactComponent as GoogleIcon } from "../../svg/google-login.svg";
import { authenticateFacebook, authenticateGoogle } from '../../services/AuthService'
import ModalWrapper from '../Inputs/ModalWrapper';

@inject('store')
@observer
class AuthModal extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      register: {

      },
      login: {
        username: {
          label: 'Email address',
          name: 'username',
          placeholder: 'Email',
          type: 'email',
          value: ''
        },
        password: {
          label: 'Password',
          name: 'password',
          placeholder: 'Password',
          type: 'password',
          value: ''
        }
      },
      register: {
        firstname: {
          label: 'First name',
          name: 'firstname',
          placeholder: 'First name',
          type: 'text',
          value: ''
        },
        username: {
          label: 'Email address',
          name: 'username',
          placeholder: 'Email',
          type: 'email',
          value: ''
        },
        password: {
          label: 'Password',
          name: 'password',
          placeholder: 'Password',
          type: 'password',
          value: ''
        }
      }
    }
  }

  close(){
    const selection = document.getSelection()
    if(selection && selection.anchorNode && selection.anchorNode.className){
      if(!selection.anchorNode.className.includes('header')){
        return
      }
    }
    this.props.store.toggleAuthModal(false)
  }

  handleChange(e){
    const { name, value } = e.target
    const { type } = this.props
    const copy = {
      ...this.state[type]
    }
    copy[name].value = value
    this.setState({
      [type]: copy
    })
  }

  handleKeyup(e){
    if(e.which === 13){
      this.handleAuth()
    }
  }

  handleAuth(){
    const { type, store } = this.props
    if(type === 'login'){
      const { login } = this.state
      store.handleLogin(
        login.username.value,
        login.password.value
      )
    }
    if(type === 'register'){
      const { register } = this.state
      const obj = {
        firstname: register.firstname.value,
        email: register.username.value,
        password: register.password.value
      }
      store.handleRegister(
        obj
      )
    }
  }

  handleModalClick(e){
    const { className } = e.target
    const selection = document.getSelection()
    if(selection && selection.anchorNode && selection.anchorNode.className){
      return
    }
    if(className && className === 'modal auth fade show'){
      this.close()
    }
  }

  getSocialLogin(){
    const { type } = this.props
    return (
      <>
        <div className='col-sm-12 col-md-10 align-center justify-center offset-md-1 mb-2 mt-4'>
          <button className='btn btn-light auth-btn' onClick={authenticateGoogle}>
            <GoogleIcon />
            {type} with Google
          </button>
        </div>
        <div className='col-sm-12 col-md-10 align-center justify-center offset-md-1 mb-3'>
          <button className='btn btn-light auth-btn' onClick={authenticateFacebook}>
            <FacebookIcon />
            {type} with Facebook
          </button>
        </div>
      </>
    )
  }

  render(){
    const colClass = `col-sm-12 col-md-10 offset-md-1`
    const { type, store } = this.props
    const inputs = Object.values(this.state[type])
    const errorClass = store.errors ? 'error show alert-danger' : 'error alert-danger'
    return (
      <ModalWrapper
        close={this.close.bind(this)}
        modalClass='auth'
      >
        <React.Fragment>
          <div className='modal-header'>
            <h5 className='modal-title'>
              {
                type === 'login' ? 'Log in' : 'Register'
              }
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.close()}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className='modal-body'>
            <div className='row no-gutters'>
            {
              this.getSocialLogin()
            }
            {
              store.errors ? 
              (
                <div className={errorClass}>
                  {
                    <span className='error-message'>{store.errors}</span>
                  }
                </div>
              )
              :
              undefined
            }
            <div className={colClass + ' mt-4 mb-5'}>
              <span className={type === 'login' ? 'auth-separator-login' : 'auth-separator-register'}>
                {
                  type === 'login' ? 'Or sign in with your email' : 'Or register with your email'
                }
              </span>
            </div>
            {
              inputs.map(input => {
                const { label, type, name, placeholder } = input
                return (
                  <div key={name} className={colClass}>
                    <div className="form-group">
                      <input
                        type={type}
                        placeholder={placeholder}
                        name={name}
                        onChange={e => this.handleChange(e)}
                        onKeyUp={e => this.handleKeyup(e)}
                        className='form-control'
                      />
                    </div>
                  </div>
                )
              })
            }
            <div className={colClass + ' mt-4 mb-3'}>
              <button 
                className='btn btn-danger auth-btn'
                onClick={() => this.handleAuth()}>
                {
                  type === 'login' ?
                  'Log in'
                  :
                  'Register'
                }
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    </ModalWrapper>
    )
  }

}

export default AuthModal